import { css } from "emotion";
import { Link } from "preact-router/match";
import LogoServices from "../../services/LogoServices";
import { max } from "../../utils/CssUtils";
import CMSComponent from "../CMSComponent";
import SignUpButton from "../global/SignUpButton";
import MobileMenu from "../MobileMenu";

const headerLogo = LogoServices.getLogo("purplePurple");

const wrapper = css({
  height: 70,
  h1: {
    textIndent: -999999,
    float: "left",
    width: 0,
    height: 0
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0px 40px",
  boxShadow: "0 2px 3px 0 rgba(32, 7, 64, 0.13)",
  position: "inherit",
  zIndex: 100,
  "@media(max-width: 990px)": {
    alignItems: "center",
    padding: "0px 14px"
  }
});

const logo = css({
  alignSelf: "center",
  marginTop: 16,
  [max(990)]: {
    marginTop: 12,
    img: {
      height: 24,
      width: 140
    }
  }
});

const navigationSection = css({
  display: "flex",
  alignItems: "baseline",
  ul: {
    listStyleType: "none",
    display: "flex"
  },
  li: {
    marginRight: 16
  },
  button: {
    fontSize: 16
  },
  "#LogIn": {
    fontSize: 16,
    marginRight: "16px",
    color: "#401479",
    fontWeight: 600
  },
  "@media(max-width: 990px)": {
    display: "none"
  }
});

const mobileWrapper = css({
  display: "none",
  zIndex: 1000,
  "@media(max-width: 990px)": {
    display: "initial"
  }
});

const Header = ({ locale }) => {
  return (
    <div className={wrapper}>
      <div className={logo}>
        <h1>Humanitix</h1>
        <Link href={`/${locale}/`} aria-label="Home">
          <img src={headerLogo} alt="Humanitix Logo" />
        </Link>
      </div>
      <div className={navigationSection}>
        <ul>
          <li>
            <Link
              activeClassName="link"
              href={`/${locale}/search`}
              aria-label="Search"
            >
              Search Events
            </Link>
          </li>
          <li>
            <Link
              activeClassName="link"
              href={`/${locale}/features-and-pricing`}
              aria-label="Features and pricing"
            >
              Features &amp; Pricing
            </Link>
          </li>
          <li>
            <Link
              activeClassName="link"
              href={`/${locale}/our-impact`}
              aria-label="Our Impact"
            >
              Our Impact
            </Link>
          </li>
          <li>
            <Link
              activeClassName="link"
              href={`/${locale}/about-us`}
              aria-label="About Us"
            >
              About Us
            </Link>
          </li>
        </ul>
        <SignUpButton ariaLabel="Sign In">Sign In</SignUpButton>
      </div>
      <div className={mobileWrapper}>
        <MobileMenu />
      </div>
    </div>
  );
};

export default CMSComponent(null, Header, 70);
